
export class CmpGenderList {
    getGenderList() {
        return [
            {key: 'male', value: 'Male'},
            {key: 'female', value: 'Female'},
            {key: 'other', value: 'Other'}
        ];
    }

    getBasicGenderList() {
        return [
            {key: 'male', value: 'Male'},
            {key: 'female', value: 'Female'}
        ];
    }

    getGenderListForFriendGroupGeneralSettings() {
        return [
            {key: 'male', value: 'Male'},
            {key: 'female', value: 'Female'},
            {key: 'all', value: 'All'},
            {key: 'other', value: 'Other'}
        ];
    }
}
